import Header from "../../Layouts/Header/Header";
import MainContainer from "../../UI/MainContainer";
import SubMainContainer from "../../UI/SubMainContainer";
import SideBar from "../../Layouts/SideBar/SideBar";
import PackagesListPageContent from "../../Package/PackagesListPageContent";

const PackagesList = () => {
  return (
    <>
      <MainContainer>
        <Header />
        <SubMainContainer>
          <SideBar />
          <PackagesListPageContent />
        </SubMainContainer>
      </MainContainer>
    </>
  );
};

export default PackagesList;
